import { useUserNotificationsStore } from '~/stores/user-notification';
import type { UserNotificationResponseItem } from './api-services/api-notfication';
import { UserHistoryOperation } from '~/types';

export const useUserNotifications = () => {
  const clientTaskId = ref();
  const isClientTaskSlideOverVisible = ref(false);
  const userNotificationsStore = useUserNotificationsStore();

  const notificationClickAction = async (
    notification: UserNotificationResponseItem,
    size: number
  ) => {
    await userNotificationsStore.updateNotificationViewedStatus(
      [notification._id],
      true
    );

    await userNotificationsStore.fetch({ size });

    if (
      notification.operation === UserHistoryOperation.CLIENT_TASK_CREATE ||
      notification.operation === UserHistoryOperation.ASSIGN_TO_TASK ||
      notification.operation === UserHistoryOperation.UN_ASSIGN_FROM_TASK
    ) {
      clientTaskId.value = notification.clientTask?._id;
      isClientTaskSlideOverVisible.value = true;
    } else {
      navigateTo(
        `/rollout-project/${notification.rolloutIdentifier}/inventory/clients/view/${notification.client?._id}`
      );
    }
  };

  return {
    notificationClickAction,
    isClientTaskSlideOverVisible,
    clientTaskId,
  };
};
